import {ComponentType, Context} from 'react';
import {isArray, keys} from 'underscore';

export function getName(target: any): string {
	if (!target) {
		return '';
	}

	if ('displayName' in target && target.displayName) {
		return target.displayName;
	}
	if ('name' in target && target.name) {
		return target.name;
	}

	if('$$typeof' in target && 'render' in target && target.$$typeof.toString() === 'Symbol(react.forward_ref)') {
		return getName(target.render);
	}

	if ('constructor' in target && target.constructor.name) {
		return target.constructor.name;
	}
	if ('prototype' in target) {
		return target.prototype?.toString();
	}
	if('$$typeof' in target) {
		return target.$$typeof.toString();
	}
	return typeof target;
}

export function contextProtection<T, P>(context: any, component: ComponentType<P> | string, requireContext?: Context<T> | string): void {
	if (!context) {
		const componentDisplayName = typeof component === 'string' ? component : getName(component);
		const contextDisplayName = typeof requireContext === 'string' ? requireContext : getName(requireContext);

		throw new Error(`[UI-Kit]:${componentDisplayName} require a ${contextDisplayName}`);
	}
}

export type ValueType = {
	array?: boolean;
	number?: boolean,
	string?: boolean,
	boolean?: boolean,
	object?: boolean,
	symbol?: boolean,
	function?: boolean,
}

export function contextConsistencyProtection<P>(context: { value: any }, component: ComponentType<P> | string, possibleValueTypes: ValueType): void {
	const value = context.value;
	const valueType = typeof value;
	if (valueType === 'undefined') {
		return;
	}

	if(!Object.values(possibleValueTypes).length) {
		return;
	}

	let containInMap = false;

	if(valueType === 'object' && isArray(value)) {
		// @ts-ignore
		containInMap = !!possibleValueTypes?.array;
	} else {
		// @ts-ignore
		containInMap = possibleValueTypes[valueType];

	}

	if (!containInMap || (possibleValueTypes?.array && !isArray(context.value))) {
		const componentDisplayName = typeof component === 'string' ? component : getName(component);
		throw new Error(`[UI-Kit]:${componentDisplayName} require a ${keys(possibleValueTypes).join('|')}`);
	}
}
